import { useMemo } from 'react';
import { difference, without } from 'lodash';

import {
  doesToolSupportPromptInstruction,
  GENERATION_TOOL,
  GENERATION_TOOL_DD,
  GENERATION_TOOL_FREESTYLE,
  GENERATION_TOOL_GROUP,
  GENERATION_TOOL_GROUPS_SORTED,
  isFreestyleGenerationTool,
  TOOL_GROUPS,
} from 'src/data/generationTool';
import { useCustomerImageGenerationSupported } from 'src/services/customer/useCustomerImageGenerationSupported';
import { useCustomerOldImageGenerationAllowed } from 'src/services/customer/useCustomerOldImageGenerationAllowed';

export const useFilteredTools = () => {
  const oldImageGenerationAllowed = useCustomerOldImageGenerationAllowed();
  const imageGenerationSupported = useCustomerImageGenerationSupported();

  return useMemo(() => {
    const TOOLS_TO_SELECT_FROM = without(
      [GENERATION_TOOL_FREESTYLE.freestyle, ...Object.values(GENERATION_TOOL_DD)],
      [
        !oldImageGenerationAllowed ? GENERATION_TOOL.imageWithDescription : null,
        !imageGenerationSupported ? GENERATION_TOOL.imageByStyle : null,
      ]
    );

    const MORE_TOOL_GROUPS = difference(
      Object.values(GENERATION_TOOL_GROUP),
      GENERATION_TOOL_GROUPS_SORTED
    );
    const sidebarOrderedTools = [];
    for (const toolGroup of [...GENERATION_TOOL_GROUPS_SORTED, ...MORE_TOOL_GROUPS]) {
      for (const tool of TOOL_GROUPS.get(toolGroup)) {
        sidebarOrderedTools.push(tool);
      }
    }

    const orderedTools = TOOLS_TO_SELECT_FROM.sort((a, b) => {
      return sidebarOrderedTools.indexOf(a) - sidebarOrderedTools.indexOf(b);
    });

    return without(orderedTools, GENERATION_TOOL.emailBody).filter(
      (tool) => doesToolSupportPromptInstruction(tool) || isFreestyleGenerationTool(tool)
    );
  }, [imageGenerationSupported, oldImageGenerationAllowed]);
};
